import { Axios } from 'utils'

export const useBinningsService = () => {
  const setBinAccepted = async (binningId: number) => {
    try {
      const response = await Axios.put<{
        status: boolean
      }>(`/binnings/${binningId}/accept_bin`)
      return response.data
    } catch (error: unknown) {
      throw error
    }
  }

  return {
    setBinAccepted,
  }
}

export default useBinningsService
